import { defineStore } from 'pinia';
import { ref } from 'vue';
import i18n from '@/i18n';

const useAppStore = defineStore('app', () => {
  const setWindowTitle = (title?: string) => {
    window.document.title = (title ? `${title} - ` : '') + `${i18n.global.t('common.websiteTitle.default')}`;
  }

  const sidebarOpen = ref(false);
  const toggleSidebar = () => { sidebarOpen.value = !sidebarOpen.value; };
  const closeSidebar = () => { sidebarOpen.value = false; };

  return {
    setWindowTitle,
    sidebarOpen,
    toggleSidebar,
    closeSidebar,
  };
});

export default useAppStore;
